import { CETokenBase } from './ce-token-base'


export class CEToken extends CETokenBase {

}